import React from 'react'
import ReporteCamiones from '../ReporteCamiones'
import ReporteCamionesEnPlaya from './ReporteCamionesEnPlaya'

function ReporteCamionesEnPlayaIngreso (props) {
  const { camionesEnPlaya } = props

  return (
    <ReporteCamiones
      buttonName='Camiones en playa'
      contenido={<ReporteCamionesEnPlaya camionesEnPlaya={camionesEnPlaya} />}
    />
  )
}

export default ReporteCamionesEnPlayaIngreso
